import { useEffect } from 'react';
import { Substitutions } from 'features';
import { useGetAllSubstitutionsQuery } from 'app/services/edpApiV1/substitutions/substitution';
import { useAppDispatch, useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import { ComponentModes, SubstitutionsTypes } from 'shared/enums';
import { viewerModel } from 'entities/viewer';
import { Table } from 'antd';
import { archiveColumns } from 'widgets/substitutions/config';
import { Substitution } from 'app/services/edpApiV1/substitutions/models';
import style from './index.module.scss';

const Archive = () => {
  const dispatch = useAppDispatch();

  const orgId = useAppSelector(viewerModel.me.selectors.getMeOrganizationId);
  const { search, personnelNumber, divisionSearch } = useAppSelector(uiModel.Substitutions.selectors.getSearchParams);
  const { page, size } = useAppSelector(uiModel.Substitutions.selectors.getPagination);

  const { data, isFetching, isLoading, refetch } = useGetAllSubstitutionsQuery({
    isArchive: true,
    search,
    personnelNumber,
    divisionSearch,
    page,
    size,
  });

  const showDrawer = (id: string) => {
    dispatch(
      uiModel.Substitutions.actions.openSubstitutionControlDrawer({
        mode: ComponentModes.view,
        substitution: { type: SubstitutionsTypes.acting, id },
      }),
    );
  };
  const onChange = (value: number, pageSize: number) => {
    dispatch(uiModel.Substitutions.actions.setPagination({ page: value, size: pageSize }));
  };

  useEffect(() => {
    if (orgId && page > 1) {
      uiModel.Substitutions.actions.setPage(1);
    } else refetch();
  }, [orgId]);

  return (
    <div className={style.wrap}>
      <Substitutions.Search />
      <Table
        rowKey={'id'}
        dataSource={data?.data}
        columns={archiveColumns}
        loading={isFetching || isLoading}
        onRow={(record: Substitution) => {
          return {
            onClick: () => {
              showDrawer(record.id);
            },
          };
        }}
        rowClassName={style.row}
        pagination={{
          defaultCurrent: 1,
          showSizeChanger: true,
          current: page,
          total: data?.pagination.total,
          pageSize: size,
          onChange,
        }}
        scroll={{ x: true }}
      />
    </div>
  );
};

export default Archive;
